import { isArray } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, withState, withHandlers } from 'recompose';

import { EmptyList } from './components';
import withLoadingList from '../../../../common/hoc/withLoaingList';
import {
  locateDuplicates,
  withLoadingListActions,
  withOwner,
  removeFromDuplicateList,
} from '../actions';

export default compose(
  withRouter,
  connect(
    null,
    {
      locateDuplicatesWithLoader: withLoadingListActions(locateDuplicates),
      locateDuplicates: withOwner(locateDuplicates),
      removeFromDuplicateList: withOwner(removeFromDuplicateList),
    },
  ),
  withState('duplicates', 'setDuplicates', []),
  withState('selectedDuplicate', 'setSelectedDuplicate', null),
  withState('checkedDuplicates', 'setCheckedDuplicates', []),
  withHandlers({
    setSelectedDuplicate: props => (selectedDuplicate) => {
      const isSameItem = (
        props.selectedDuplicate &&
        props.selectedDuplicate.survivingCustomer.id === selectedDuplicate.survivingCustomer.id
      );
      if (isSameItem) {
        return;
      }

      props.setCheckedDuplicates([selectedDuplicate.survivingCustomer.id]);
      props.setSelectedDuplicate(selectedDuplicate);

      if (!selectedDuplicate.duplicates.length) {
        props.locateDuplicates(selectedDuplicate.survivingCustomer.id)
          .then(props.setSelectedDuplicate);
      }
    },
    onDuplicateChange: props => (duplicate) => {
      if (props.checkedDuplicates.includes(duplicate.id)) {
        const nextCheckedDuplicates = props.checkedDuplicates.filter(d => d !== duplicate.id);
        props.setCheckedDuplicates(nextCheckedDuplicates);
        return;
      }

      const nextCheckedDuplicates = [...props.checkedDuplicates, duplicate.id];
      props.setCheckedDuplicates(nextCheckedDuplicates);
    },
    isDuplicateChecked: props => duplicate => props.checkedDuplicates.includes(duplicate.id),
    canBeChanged: props => (duplicate) => {
      if (duplicate.id === props.selectedDuplicate.survivingCustomer.id) {
        return false;
      }
      return props.checkedDuplicates.includes(duplicate.id) || props.checkedDuplicates.length < 3;
    },
    selectForMerge: props => () => {
      props.setCustomerIds(props.checkedDuplicates);
      props.setSurvivingCustomerId(props.selectedDuplicate.survivingCustomer.id);
      props.setIsMobileSurvivingCustomer(props.selectedDuplicate.survivingCustomer.hasRegularUser);
    },
    isMobileCustomer: () => customer => customer.hasRegularUser,
    removeFromDuplicateList: props => async () => {
      const customerId = props.selectedDuplicate.survivingCustomer.id;
      await props.removeFromDuplicateList(customerId);
      props.setSelectedDuplicate(null);
      props.setDuplicates(props.duplicates.filter(duplicate => duplicate.survivingCustomer.id !== customerId));
    },
  }),
  lifecycle({
    componentWillMount() {
      this.props.locateDuplicatesWithLoader(this.props.params.customerId)
        .then((res) => {
          // locating all duplicates
          // response is an array of surviving customers
          if (isArray(res)) {
            const duplicates = res.map(customer => ({
              survivingCustomer: customer,
              duplicates: [],
            }));
            this.props.setDuplicates(duplicates);
            return;
          }

          // in some cases surviving customer might be null
          if (!res.survivingCustomer) {
            this.props.setDuplicates([]);
            return;
          }

          // locating duplicates for a particular customer
          // response is an object with a surviving customer and array of duplicates
          this.props.setDuplicates([res]);
          this.props.setSelectedDuplicate(res);
        });
    },
  }),
  withLoadingList(
    props => props.duplicates,
    EmptyList,
  ),
);
